var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{class:_vm.isMobile ? 'mobile-container' : 'desktop-container',attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"lg":"5","order":"1"}},[_c('b-card',{staticClass:"abi-card"},[_c('div',[_c('kykyviisari-graphs')],1)])],1),_c('b-col',{attrs:{"lg":"7","order":"2"}},[_c('b-row',[_c('b-col',[_c('b-button',{staticClass:"kykyviisari-button btn-purple",attrs:{"disabled":_vm.linkLoading},on:{"click":_vm.goToAbilitator}},[_c('h4',[_vm._v(_vm._s(_vm.$t("go-to-abilitator")))])])],1)],1),_c('b-card',{staticClass:"abi-card"},[_c('b-row',{attrs:{"align-h":"start"}},[_c('b-col',{attrs:{"lg":"12"}},[(_vm.tableLoading)?_c('b-skeleton-table',{attrs:{"rows":2,"columns":8,"table-props":{ bordered: false, striped: true }}}):_vm._e(),(!_vm.tableLoading)?_c('b-table-simple',{attrs:{"striped":"","hover":"","stacked":"lg"}},[_c('b-thead',[_c('b-tr',[_c('b-th',[_vm._v("#")]),_c('b-th',[_vm._v(_vm._s(_vm.$t("abil-table.answer-date")))]),_c('b-th',[_vm._v(_vm._s(_vm.$t("abil-table.gen")))]),_c('b-th',[_vm._v(_vm._s(_vm.$t("abil-table.part")))]),_c('b-th',[_vm._v(_vm._s(_vm.$t("abil-table.mind")))]),_c('b-th',[_vm._v(_vm._s(_vm.$t("abil-table.weekdays")))]),_c('b-th',[_vm._v(_vm._s(_vm.$t("abil-table.skills")))]),_c('b-th',[_vm._v(_vm._s(_vm.$t("abil-table.body")))])],1)],1),_c('b-tbody',_vm._l((_vm.kykyviisarit),function(kv,index){return _c('b-tr',{key:kv.uid},[_c('b-td',{attrs:{"stacked-heading":"#"}},[_vm._v(_vm._s(index + 1))]),_c('b-td',{attrs:{"stacked-heading":_vm.$t('abil-table.answer-date')}},[_vm._v(_vm._s(_vm.formatDate(kv.loppupvm)))]),_c('b-td',{attrs:{"stacked-heading":_vm.$t('abil-table.gen')}},[_vm._v(_vm._s(_vm.formatPercents(kv.prosenttiB))+" "),(_vm.displayCaret(index, kv.prosenttiB))?_c('div',{staticStyle:{"display":"inline"}},[(
													_vm.caretColor(
														_vm.kykyviisarit[index].prosenttiB,
														_vm.kykyviisarit[index + 1].prosenttiB
													) == 1
												)?_c('b-icon',{attrs:{"icon":"caret-up-fill","variant":"success"}}):_vm._e(),(
													_vm.caretColor(
														_vm.kykyviisarit[index].prosenttiB,
														_vm.kykyviisarit[index + 1].prosenttiB
													) == 2
												)?_c('b-icon',{attrs:{"icon":"caret-down-fill","variant":"danger"}}):_vm._e(),(
													_vm.caretColor(
														_vm.kykyviisarit[index].prosenttiB,
														_vm.kykyviisarit[index + 1].prosenttiB
													) == 3
												)?_c('b-icon',{attrs:{"icon":"dash"}}):_vm._e()],1):_vm._e()]),_c('b-td',{attrs:{"stacked-heading":_vm.$t('abil-table.part')}},[_vm._v(_vm._s(_vm.formatPercents(kv.prosenttiC))+" "),(_vm.displayCaret(index, kv.prosenttiC))?_c('div',{staticStyle:{"display":"inline"}},[(
													_vm.caretColor(
														_vm.kykyviisarit[index].prosenttiC,
														_vm.kykyviisarit[index + 1].prosenttiC
													) == 1
												)?_c('b-icon',{attrs:{"icon":"caret-up-fill","variant":"success"}}):_vm._e(),(
													_vm.caretColor(
														_vm.kykyviisarit[index].prosenttiC,
														_vm.kykyviisarit[index + 1].prosenttiC
													) == 2
												)?_c('b-icon',{attrs:{"icon":"caret-down-fill","variant":"danger"}}):_vm._e(),(
													_vm.caretColor(
														_vm.kykyviisarit[index].prosenttiC,
														_vm.kykyviisarit[index + 1].prosenttiC
													) == 3
												)?_c('b-icon',{attrs:{"icon":"dash"}}):_vm._e()],1):_vm._e()]),_c('b-td',{attrs:{"stacked-heading":_vm.$t('abil-table.mind')}},[_vm._v(_vm._s(_vm.formatPercents(kv.prosenttiD))+" "),(_vm.displayCaret(index, kv.prosenttiD))?_c('div',{staticStyle:{"display":"inline"}},[(
													_vm.caretColor(
														_vm.kykyviisarit[index].prosenttiD,
														_vm.kykyviisarit[index + 1].prosenttiD
													) == 1
												)?_c('b-icon',{attrs:{"icon":"caret-up-fill","variant":"success"}}):_vm._e(),(
													_vm.caretColor(
														_vm.kykyviisarit[index].prosenttiD,
														_vm.kykyviisarit[index + 1].prosenttiD
													) == 2
												)?_c('b-icon',{attrs:{"icon":"caret-down-fill","variant":"danger"}}):_vm._e(),(
													_vm.caretColor(
														_vm.kykyviisarit[index].prosenttiD,
														_vm.kykyviisarit[index + 1].prosenttiD
													) == 3
												)?_c('b-icon',{attrs:{"icon":"dash"}}):_vm._e()],1):_vm._e()]),_c('b-td',{attrs:{"stacked-heading":_vm.$t('abil-table.weekdays')}},[_vm._v(_vm._s(_vm.formatPercents(kv.prosenttiE))+" "),(_vm.displayCaret(index, kv.prosenttiE))?_c('div',{staticStyle:{"display":"inline"}},[(
													_vm.caretColor(
														_vm.kykyviisarit[index].prosenttiE,
														_vm.kykyviisarit[index + 1].prosenttiE
													) == 1
												)?_c('b-icon',{attrs:{"icon":"caret-up-fill","variant":"success"}}):_vm._e(),(
													_vm.caretColor(
														_vm.kykyviisarit[index].prosenttiE,
														_vm.kykyviisarit[index + 1].prosenttiE
													) == 2
												)?_c('b-icon',{attrs:{"icon":"caret-down-fill","variant":"danger"}}):_vm._e(),(
													_vm.caretColor(
														_vm.kykyviisarit[index].prosenttiE,
														_vm.kykyviisarit[index + 1].prosenttiE
													) == 3
												)?_c('b-icon',{attrs:{"icon":"dash"}}):_vm._e()],1):_vm._e()]),_c('b-td',{attrs:{"stacked-heading":_vm.$t('abil-table.skills')}},[_vm._v(_vm._s(_vm.formatPercents(kv.prosenttiF))+" "),(_vm.displayCaret(index, kv.prosenttiF))?_c('div',{staticStyle:{"display":"inline"}},[(
													_vm.caretColor(
														_vm.kykyviisarit[index].prosenttiF,
														_vm.kykyviisarit[index + 1].prosenttiF
													) == 1
												)?_c('b-icon',{attrs:{"icon":"caret-up-fill","variant":"success"}}):_vm._e(),(
													_vm.caretColor(
														_vm.kykyviisarit[index].prosenttiF,
														_vm.kykyviisarit[index + 1].prosenttiF
													) == 2
												)?_c('b-icon',{attrs:{"icon":"caret-down-fill","variant":"danger"}}):_vm._e(),(
													_vm.caretColor(
														_vm.kykyviisarit[index].prosenttiF,
														_vm.kykyviisarit[index + 1].prosenttiF
													) == 3
												)?_c('b-icon',{attrs:{"icon":"dash"}}):_vm._e()],1):_vm._e()]),_c('b-td',{attrs:{"stacked-heading":_vm.$t('abil-table.body')}},[_vm._v(_vm._s(_vm.formatPercents(kv.prosenttiG))+" "),(_vm.displayCaret(index, kv.prosenttiG))?_c('div',{staticStyle:{"display":"inline"}},[(
													_vm.caretColor(
														_vm.kykyviisarit[index].prosenttiG,
														_vm.kykyviisarit[index + 1].prosenttiG
													) == 1
												)?_c('b-icon',{attrs:{"icon":"caret-up-fill","variant":"success"}}):_vm._e(),(
													_vm.caretColor(
														_vm.kykyviisarit[index].prosenttiG,
														_vm.kykyviisarit[index + 1].prosenttiG
													) == 2
												)?_c('b-icon',{attrs:{"icon":"caret-down-fill","variant":"danger"}}):_vm._e(),(
													_vm.caretColor(
														_vm.kykyviisarit[index].prosenttiG,
														_vm.kykyviisarit[index + 1].prosenttiG
													) == 3
												)?_c('b-icon',{attrs:{"icon":"dash"}}):_vm._e()],1):_vm._e()])],1)}),1)],1):_vm._e(),(_vm.kykyviisarit.length == 0 && !_vm.tableLoading)?_c('div',[_vm._v(" "+_vm._s(_vm.$t("no-abilitators"))+" ")]):_vm._e()],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }